import { Box } from '@mui/material';
import { twMerge } from 'tailwind-merge';
import { type JSX, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { Routes } from 'config';

import { Button } from '../button';
import { Loader } from '../loader';

import { DetailsProps } from './types';

export const Details = ({
  id,
  error,
  isError,
  refetch,
  children,
  isLoading,
  className = '',
  childrenClassName,
  loaderAbsolutePosition,
  loaderFullScreen = false,
  notFoundPath = Routes.NotFound,
}: DetailsProps): JSX.Element => {
  const hasChildren = !!children;
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoading && !isError && !hasChildren) {
      navigate(notFoundPath, { replace: true });
    }
  }, [isError, isLoading, hasChildren, notFoundPath, navigate]);

  const getMainElement = () => {
    if (isLoading) {
      return (
        <Loader
          isLoading
          fullScreen={loaderFullScreen}
          absolutePosition={loaderAbsolutePosition}
        />
      );
    } else if (isError) {
      return (
        <Box className="flex flex-1 flex-col items-center justify-center gap-2">
          <Box>{error}</Box>
          {refetch && <Button onClick={refetch}>Retry</Button>}
        </Box>
      );
    } else {
      return (
        <Box className={twMerge('flex-1', childrenClassName)}>{children}</Box>
      );
    }
  };

  return (
    <Box
      id={id}
      className={twMerge(className, 'flex h-full min-h-0 w-full flex-col')}
    >
      {getMainElement()}
    </Box>
  );
};
